<template>
  <div class="nv-error">
    <div class="nv-error__card">
      <img src="/logo.png" alt="Nilvera" class="nv-error__logo"/>
      <span class="nv-error__code">404</span>
      <h1 class="nv-error__title">Aradığınız sayfa bulunamadı</h1>
      <p class="nv-error__text">
        Ulaşmaya çalıştığınız sayfa taşınmış veya kaldırılmış olabilir. Aktivasyon girişine dönerek işlemlerinize
        devam edebilirsiniz.
      </p>
      <v-btn depressed large color="primary" class="nv-btn" @click="RouteRedirect">
        <v-icon small left>mdi-arrow-left</v-icon>
        Aktivasyon Girişe Geri Dön
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error-1",
  methods: {
    RouteRedirect() {
      window.location.pathname = 'login'
    }
  }
};
</script>
